module.exports = __webpack_public_path__ + "img/my_qrcode_ins_us.ee970e9.webp";